<template>
  <div>
    <List :reportType="1"></List>
  </div>
</template>
<script>
  import { wxShare } from '@/helpers/wxconfig'
  import List from './components/list.vue'
  export default {
    name: 'dailylist',
    data() {
      return {

      }
    },
    components: {
      List
    },
    methods: {

    },
    mounted() {
      wxShare('预警日报','快来看看我分享的网站:预警日报');
    }
  }
</script>
<style scoped>

</style>
